import { Paper, Typography } from '@sanlam-glacier/app-common/components';
import { CreateNewProposalButton } from 'modules/new-business/components/molecules/create-new-proposal-button/CreateNewProposalButton';
import style from './no-proposal.module.scss';
import { AllowFor } from 'modules/app/components/atoms/feature-flags/AllowFor';
import { SecurityAccessFeaturesEnum } from 'bff';
import { useConfig } from 'providers/config/ConfigProvider';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';

export const NoProposals = () => {
  const { theme } = useConfig();
  const { emptyProposal } = useGetBranding(theme);
  return (
    <>
      <Paper className={style.proposalOverviewBackgroundPaper} color={Paper.COLOR.SECONDARY}>
        <div className={style.proposalOverviewBodyContainer}>
          <div className={style.proposalOverviewBody}>
            <img
              src={emptyProposal}
              loading='lazy'
              alt='empty-proposals-graphic'
              className={style.placeholder}
            />
            <Typography
              align={Typography.ALIGN.CENTER}
              variant={Typography.VARIANT.H3}
              weight={Typography.WEIGHT.BOLD}
            >
              You have not created any proposals yet.
            </Typography>
            <AllowFor features={[SecurityAccessFeaturesEnum.CreateProposal]}>
              <Typography
                align={Typography.ALIGN.CENTER}
                variant={Typography.VARIANT.B1}
                weight={Typography.WEIGHT.LIGHT}
              >
                Please click the button below to start a new proposal.
              </Typography>
              <CreateNewProposalButton />
            </AllowFor>
          </div>
        </div>
      </Paper>
    </>
  );
};
